<template>
  <div>
    <datatable
      title="Developer Interview Articles"
      :is_createable="true"
      @edit_click="editClick"
      @create="createArticle"
      @delete="deleteArticle"
      @comments="openArticleComments"
      :operations="operations"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
import { getArticles, deleteArticle } from '@/services/developerApi.js'
export default {
  name: 'developer-interview-articles',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'title',
          value: 'title'
        },
        {
          name: 'content',
          value: 'content'
        }
      ],
      data: [],
      operations: [
        { name: 'comments' }
      ]
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    async init () {
      this.data = await (await getArticles()).data
    },
    editClick (data) {
      this.create({
        designator: 'developer-interview-article-form',
        component_name: 'DeveloperInterviewArticleForm',
        modal_title: data.title,
        data
      })
    },
    createArticle () {
      this.create({
        designator: 'developer-interview-article-form',
        component_name: 'DeveloperInterviewArticleForm',
        modal_title: 'Create new article',
        is_create: true
      })
    },
    async deleteArticle ({ id }) {
      try {
        await deleteArticle(id)
        this.$utils.emit('show_toast', { text: 'נמחק בהצלחה' })
      } catch (e) {}
    },
    openArticleComments (data) {
      let link = this.$router.resolve({ name: 'developer-interview-article-comments', query: { title: data.title, article_id: data.id } })
      this.$utils.openInNewTab(link.href)
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped></style>
